import React from "react";
import { useNavigate } from "react-router-dom";

const Cards = ({ icon, name, cardtext, readmore, linkTo }) => {
  const navigate = useNavigate();

  return (
    <div className="card text-white bg-dark mb-3" style={{ maxWidth: "18rem" }}>
      <div className="card-body text-center">
        <div>{icon}</div>
        <h5 className="card-title mt-3">{name}</h5>
        <p className="card-text">{cardtext}</p>

        {readmore && (
          <button
            className="btn btn-outline-light"
            onClick={() => linkTo && navigate(linkTo)}
          >
            {readmore}
          </button>
        )}
      </div>
    </div>
  );
};


export default Cards;